import { render, staticRenderFns } from "./ChatQuickActions.vue?vue&type=template&id=2f6f57ba"
import script from "./ChatQuickActions.vue?vue&type=script&lang=js"
export * from "./ChatQuickActions.vue?vue&type=script&lang=js"
import style0 from "./ChatQuickActions.vue?vue&type=style&index=0&id=2f6f57ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports